var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00391 6.29175C1.00391 6.29175 3.50353 1.29175 7.87863 1.29175C12.2537 1.29175 14.7533 6.29175 14.7533 6.29175C14.7533 6.29175 12.2537 11.2917 7.87863 11.2917C3.50353 11.2917 1.00391 6.29175 1.00391 6.29175Z",
    stroke: "#707070",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7553 6.29171C9.7553 6.66247 9.64537 7.0249 9.43941 7.33318C9.23344 7.64146 8.94069 7.88174 8.59818 8.02366C8.25566 8.16557 7.87875 8.20274 7.51511 8.13047C7.15147 8.05819 6.81743 7.87972 6.55522 7.6176C6.293 7.35549 6.11439 7.02152 6.04197 6.65791C5.96955 6.2943 6.00657 5.91738 6.14835 5.5748C6.29013 5.23223 6.5303 4.93939 6.8385 4.7333C7.1467 4.52721 7.50909 4.41714 7.87984 4.41699C8.12609 4.41689 8.36996 4.46531 8.59749 4.55948C8.82503 4.65365 9.03178 4.79173 9.20595 4.96582C9.38011 5.13992 9.51827 5.34662 9.61253 5.57412C9.70679 5.80162 9.7553 6.04546 9.7553 6.29171Z",
    stroke: "#707070",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.1c49bb806283669c94e3e2b9993c1e89.svg";
export { ForwardRef as ReactComponent };